<template>
    <div>
        <Modal
                v-model="modal"
                :title="title"
                width="430"
                @on-ok="callbackFunc"
        >
            <p>确认删除吗？删除后不可恢复。</p>
        </Modal>
    </div>
</template>
<script>
    export default {
        name:"deleteModal",
        props:{
            callbackFunc:{
                type:Function,
                required:true,
            },
            title:{
                type:String,
                requred:true,
            }
        },
        methods:{
            isshow(flag) {
                this.modal = flag
            },
        },
        data(){
            return {
                modal:false,
            }
        }
    }
</script>
